export default "__VITE_ASSET__8GB8$vbF__"